<div class="column">
  <div class="row center-center pager-container">
    <i class="ri-icon icon rif-icon_arrow pager-icon rotated-left spacing" [ngClass]="canSelectPreviousPage() ? 'enabled' : 'disabled'" (click)="selectPreviousPage()"></i>
    <input class="pager-input" type="text" [value]="currentPage" appFilterInput [allowDot]="false" [allowComma]="false"
          (keyup.enter)="onCurrentPageChanged($event)" 
          (keyup.tab)="onCurrentPageChanged($event)"
          (blur)="onCurrentPageChanged($event)"/>
    <div class="separator">/</div>
    <div class="page-count spacing">{{ maxPageCount }}</div>
    <i class="ri-icon icon rif-icon_arrow pager-icon rotated-right spacing" [ngClass]="canSelectNextPage() ? 'enabled' : 'disabled'" (click)="selectNextPage()"></i>
  </div>  
</div>
